<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Company Name or ID</h3>
    <div>
      <div>
        <div>
          <div>
            <p class="NOTE">
              As an administrator, you have access to at least one location for your company (some companies have only 1 location to start with). You
              can upload new users, changes and points for all of your locations at the same time. However, you must specify a location for each user.
              This can be done using the location <em>name</em> or using the special location <em>id number</em>. Whichever one you use, it must match
              exactly the name <em>or</em> ID in the table below. The table below is a list of the locations that <em>you are authorized</em> to
              administrate. If you put anything else in the id or name field, it will result errors in your data and you will have to edit each
              mis-identified record.
            </p>
            <p class="note">
              To put a name or ID In the Access Database, you can use the form provide when entering records, or you can open up the
              <em>Users</em> table and edit the data dirctly.
            </p>

            <div>
              <h5>Access "Users" Table</h5>
            </div>
            <p class="note">
              To edit the company name or id in Excel, simply open the "userfile" spreadsheet and find the correct column(s). Match up the username
              and type in the id or location name under company_name or company_id. NOTE: in excel you can type in one time and use the "fill-down"
              feature (control-d) to copy it into each subsequent cell in the column.
            </p>
            <div></div>
            <br />
            <br /><br />
          </div>
        </div>
        <div>
          <div>
            <br />

            <p class="caution" style="font-size: 12pt">
              Remember, if you use the "company_name" field the name must <em><strong>exactly match</strong></em> a name from the table below. If you
              use the company_id field, the number must exactly match the number in the ID column below. This field is used to match up users with
              locations. If you don't use locations or you are only administering 1 location, just make sure to insert the number below in all the
              "company_id" fields in your access db or excel file. If you are using excel, check out the "fill-down" feature (control-D).
            </p>
            <br />

            <table class="table">
              <thead>
                <tr>
                  <th colspan="3">Authorized companies or locations.</th>
                </tr>
                <tr>
                  <th class="regWhite">Location</th>
                  <th class="regWhite">ID</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="note">Divvy Engagement Solutions</td>

                  <td class="Note">500229</td>
                </tr>
              </tbody>
            </table>
            <table class="table  table-bordered">
              <thead>
                <tr>
                  <th scope="col">
                    Authorized Programs
                  </th>
                  <th scope="col">ID #</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>500229</td>
                </tr>
                <tr>
                  <td>Feb17TestProgram</td>
                  <td>500294</td>
                </tr>

                <tr>
                  <td>Mahesh Yadav</td>
                  <td>500293</td>
                </tr>

                <tr>
                  <td>Test Annual Awards Program-100</td>
                  <td>500291</td>
                </tr>

                <tr>
                  <td>Test Service Anniversary Award</td>
                  <td>500285</td>
                </tr>

                <tr>
                  <td>testing program</td>
                  <td>500288</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'COMatrix',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
